import styles from './style.module.css';
import { SliderClose  , SliderOpens} from '../../../../../assets';
import CircleArrowButton from '../../../../../design-system/lib/CircleArrowButton';


interface ISidebarSlider {
    setIsOpen : Function
    isOpen : boolean
  }
export const SidebarSlider = ({setIsOpen , isOpen}:ISidebarSlider) => {


    return <div className={styles.SidebarSlider}>
          <CircleArrowButton isOpen={isOpen} size='24px'onClick={()=>{setIsOpen(!isOpen)}} />
    </div>

};




